import { InputHTMLAttributes, useEffect, useState } from "react";
import { Accordion, Button, Form } from "react-bootstrap";
import { NoData, Spinner } from "@whitespace/whitespace-ui";
import IGroup from "interfaces/models/IGroup";
import { Search } from "react-bootstrap-icons";

interface GroupsFilterProps extends InputHTMLAttributes<HTMLInputElement> {
  register: any;
  accordionKey: string;
  hasFilterChanged : boolean;
  groups: IGroup[];
  handleOnChange : (e? : any) => void;
}

const GroupsFilter : React.FC<GroupsFilterProps> = ({
  register, accordionKey, hasFilterChanged, groups, handleOnChange
} : GroupsFilterProps) => {
  const [filteredGroups, setFilteredGroups] = useState<IGroup[]>(groups);
  const [searchValue, setSearchValue] = useState<string>("");

  const handleOnSearchChange = (e : any) => {
    setSearchValue(e.target.value);
  };

  const alphabeticalSort = (unsorted : IGroup[]) : IGroup[] => unsorted.sort((a, b) => {
    const ga = a.groupName.toLowerCase();
    const gb = b.groupName.toLowerCase();

    if (ga < gb) {
      return -1;
    }
    if (ga > gb) {
      return 1;
    }
    return 0;
  });

  const handleOnGroupSearch = () => {
    if (searchValue) {
      const searchTerm = new RegExp(searchValue, "gi");
      const tempGroups = groups.filter(group => group.groupName.match(searchTerm));
      setFilteredGroups(alphabeticalSort(tempGroups));
    } else {
      setFilteredGroups(alphabeticalSort(groups));
    }
  };

  useEffect(() => {
    if (searchValue === "") {
      handleOnGroupSearch();
    }
  }, [searchValue]);

  return (
    <>
      <Accordion key={accordionKey} defaultActiveKey={hasFilterChanged ? "accordionGroups" : ""}>
        <Accordion.Item eventKey="accordionGroups">
          <Accordion.Header>
            Groups
            <Spinner className="left-margin-small" animation="grow" visible={false} spinnerText="Loading" variant="info" />
          </Accordion.Header>
          <Accordion.Body>
            <section>
              <Form.Control
                {...register("groupSearch", {
                  required: false
                })}
                type="search"
                key="groupSearch"
                data-testid="groupSearch"
                aria-required="true"
                aria-label="textual search"
                aria-invalid="false"
                name="groupSearch"
                defaultValue=""
                className="ms-1 mb-2 input-search"
                placeholder="Search for....."
                onChange={e => handleOnSearchChange(e)}
              />
              <Button
                data-testid="btnGroupSearchEntry"
                aria-label="Search"
                type="button"
                onClick={handleOnGroupSearch}
              >
                <Search />
              </Button>
              <Form.Group controlId="groups">
                {filteredGroups.length > 0 && (filteredGroups.map((group : IGroup) => (
                  <Form.Check
                    {...register("group", {
                      required: true
                    })}
                    key={`group${group.groupId}`}
                    id={`group${group.groupId}`}
                    data-testid={`group${group.groupId}`}
                    name="group"
                    type="radio"
                    label={`${group.groupName}`}
                    value={group.groupId}
                    className="left-margin-medium"
                    onInput={e => { handleOnChange(e); }}
                  />
                )))}
                <NoData visible={filteredGroups.length === 0} description="No Groups found." />
              </Form.Group>
            </section>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </>
  );
};

export default GroupsFilter;
